import { Title } from "@clipboard-health/ui-react";
import { Stack } from "@mui/material";

import { SupportArticleLink } from "./SupportArticleLink";
import { type SupportArticle } from "./types";

interface SupportArticleGroupProps {
  title: string;
  supportArticles: SupportArticle[];
}

export function SupportArticleGroup(props: SupportArticleGroupProps) {
  const { title, supportArticles } = props;

  return (
    <Stack>
      <Title component="h2">{title}</Title>
      {supportArticles.map((article) => (
        <SupportArticleLink key={article.attributes.distributionUrl} supportArticle={article} />
      ))}
    </Stack>
  );
}
